module.exports = __webpack_public_path__ + "img/global-filter.55ae4de5.svg";